export default "__VITE_ASSET__C3fOCrRR__"